/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export interface UserBodyDto {
  /** Email address of the user */
  email: string;
  /** First name of the user */
  firstName?: string;
  /** Last name of the user */
  lastName?: string;
  /** Organization of the user */
  organization: string;
  /** Country code of the user */
  countryCode: string;
}
